module.exports = __webpack_public_path__ + "img/huawei.1999baa4.png";